export const handleChangeInstallmentsBarcodeGeneratePage = (name, value) => ({
    type: 'CHANGE_INSTALLMENTS_BARCODE_GENERATE_PAGE', name, value
});
